"use client"

import type React from "react"

interface SyncDirectionSectionProps {
  direction: string
  onEdit: () => void
}

const SyncDirectionSection: React.FC<SyncDirectionSectionProps> = ({ direction, onEdit }) => (
  <div className="review-section direction-section">
    <div className="section-header">
      <h2>Sync Direction</h2>
      <button className="edit-button" onClick={onEdit}>
        Edit
      </button>
    </div>
    <div className="direction-value">
      <span className="direction-badge">{direction}</span>
    </div>
  </div>
)

export default SyncDirectionSection
